
import Vue from "vue";
import R2FService from "./api/R2FService";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router/routerConfig";
import { read, save } from "./storage/session";
import { clear } from "./storage/session";

import ElementLocale from "element-ui/lib/locale";
Vue.use(Element);

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
